import { render } from "./ProjectInformation.vue?vue&type=template&id=6f9602d2&scoped=true"
import script from "./ProjectInformation.vue?vue&type=script&lang=js"
export * from "./ProjectInformation.vue?vue&type=script&lang=js"

import "./ProjectInformation.vue?vue&type=style&index=0&id=6f9602d2&scoped=true&lang=css"

import exportComponent from "/Users/admin/Desktop/bos-vue/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9602d2"]])

export default __exports__